// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { format } from "date-fns";

import { type CreateProfessionalReferenceRequest, type ReferenceFormData } from "../types";

/**
 * Transform form data to API request payload
 *
 * IMPORTANT: Backend API inconsistency:
 * - POST expects 1-indexed months (1 = January, 12 = December)
 * - GET returns 0-indexed months (0 = January, 11 = December)
 */
export function transformFormDataToRequest(
  formData: ReferenceFormData
): CreateProfessionalReferenceRequest {
  return {
    employerName: formData.employerName.trim(),
    workerTitle: formData.workerTitle.trim(),
    referenceFirstName: formData.referenceFirstName.trim(),
    referenceLastName: formData.referenceLastName.trim(),
    fromMonth: formData.employmentStartDate.getMonth() + 1, // API expects 1-indexed
    fromYear: formData.employmentStartDate.getFullYear(),
    toMonth: formData.employmentEndDate.getMonth() + 1, // API expects 1-indexed
    toYear: formData.employmentEndDate.getFullYear(),
  };
}

/**
 * Format month and year to readable date string
 * @param month - 0-indexed month (0 = January) from API
 * @param year - 4-digit year
 */
export function formatMonthYear(month: number, year: number): string {
  const date = new Date(year, month, 1);
  return format(date, "MMM yyyy");
}

/**
 * Format employment period as date range
 */
export function formatEmploymentPeriod(
  fromMonth: number,
  fromYear: number,
  toMonth: number,
  toYear: number
): string {
  const from = formatMonthYear(fromMonth, fromYear);
  const to = formatMonthYear(toMonth, toYear);
  return `${from} - ${to}`;
}
